import { useBackendMe } from './useBackendMe';
import { useCurrentUser } from './useCurrentUser';

export interface CommentIdentity {
  /** Email exactement tel que stocké en DynamoDB (source = accessToken JWT).
   *  Undefined pendant le chargement initial ou si le BFF est indisponible. */
  currentUserEmail: string | undefined;
  /** True si l'utilisateur est admin (peut éditer/supprimer tous les commentaires). */
  isAdmin: boolean;
}

/**
 * Source de vérité unique pour l'identité dans le système de commentaires.
 * Préfère l'email du backend (même source JWT que le stockage DynamoDB) ;
 * tombe en fallback sur useCurrentUser en local-dev sans BFF.
 */
export function useCommentIdentity(): CommentIdentity {
  const { email: backendEmail, isAdmin } = useBackendMe();
  const { email: localEmail } = useCurrentUser();
  return {
    currentUserEmail: backendEmail ?? localEmail,
    isAdmin,
  };
}
